import { lazy } from 'react';

// project imports
import Loadable from 'ui-component/Loadable';
import MinimalLayout from 'layout/MinimalLayout';

const PaymentView = Loadable(lazy(() => import('views/public/payment')));

// ==============================|| Public Payment ROUTING ||============================== //

const PublicPaymentRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/payment',
      element: <PaymentView />
    }
  ]
};

export default PublicPaymentRoutes;
